<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from '@/components/Page-header';
import appConfig from "../../../../../app.config";


/**
 * Form elements component
 */
export default {
 page: {
    title: "Evaluación médica ocupacional",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "",
      items: [
        {
          text: "Base de conocimiento",
          href: "/forms/general",
        },
        {
          text: "Evaluación médica ocupacional",
          active: true,
        },
      ],
      text: `
          Ad leggings keytar, brunch id art party dolor labore. Pitchfork yr enim lo-fi before they sold out qui. Tumblr farm-to-table bicycle rights whatever. Anim keffiyeh carles cardigan. Velit seitan mcsweeney's photo booth 3 wolf moon irure. Cosby sweater lomo jean shorts, williamsburg hoodie minim qui you probably haven't heard of them et cardigan trust fund culpa biodiesel wes anderson aesthetic. Nihil tattooed accusamus, cred irony biodiesel keffiyeh artisan ullamco consequat.
        `,
      text2: `Labore sit culpa commodo elit adipisicing sit aliquip elit proident voluptate minim mollit nostrud aute reprehenderit do. Mollit excepteur eu Lorem ipsum anim commodo sint labore Lorem in exercitation velit incididunt. Occaecat consectetur nisi in occaecat proident minim enim sunt reprehenderit exercitation cupidatat et do officia. Aliquip consequat ad labore labore mollit ut amet. Sit pariatur tempor proident in veniam culpa aliqua excepteur elit magna fugiat eiusmod amet officia.`,
    };
  },
  methods: {
    /**
     * Scrollspy
     */
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    },
    
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  

   
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-12">
        <div class="card">
          <div class="card-body"> 
            <div class="row">
              <div class="col-6">
                <h4 class="header-title">Evaluación médica ocupacional</h4>
              </div>

              <div class="col-6 text-right">
                <a href="/forms/general" class="btn btn-secondary m-l-5 ml-1" id="tooltip">
                  <i class="fas fa-arrow-left"></i>
                </a>
                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
              </div>
            </div>

           

            <br>
            <b-row>
              <b-col cols="4">
                <b-list-group v-b-scrollspy:listgroup-ex>
                 <!-- <b-list-group-item href="#list-item-1"
                    >¿QUÉ ES EL COMITÉ COPPASST?</b-list-group-item
                  >-->
                  <b-list-group-item href="#list-item-1"
                    >¿Que es la evaluación médica ocupacional? </b-list-group-item
                  >
                 <b-list-group-item href="#list-item-2"
                    >¿Quién debe Cumplir? </b-list-group-item
                  >
                  <b-list-group-item href="#list-item-3"
                    >¿Cuál es la frecuencia definida para la realización de los exámenes médicos ocupacionales periódicos, de conformidad con la normatividad vigente? </b-list-group-item
                  >
                  <b-list-group-item href="#list-item-4"
                    >¿Cuáles son los criterios?</b-list-group-item
                  >                  
                  <!-- <b-list-group-item href="#list-item-5"
                    >!.1.2</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-6"
                    >1.1.3</b-list-group-item
                  > -->
                  
                 
                </b-list-group>
              </b-col>

              <b-col cols="8">
                <div
                  id="listgroup-ex"
                  style="position: relative; overflow-y: auto; height: 300px"
                >
                  <!--<h4 id="list-item-1">¿Qué es el comité copasst? </h4>
                  <p>...</p>-->
                  <h4 id="list-item-1">EXAMENES OCUPACIONALES </h4>
                   <p><h5>Definición:</h5>

                  La Resolución 1843 de 2025 del Ministerio del Trabajo regula cómo se deben hacer las evaluaciones médicas ocupacionales en el país, así como el manejo de las historias clínicas de los trabajadores. Aplica a todos los empleadores y trabajadores, sin importar el tipo de contrato o sector.<br /><br />

                  <h5>Objetivo:</h5>

                  La resolución busca regular de manera clara y técnica la realización de evaluaciones médicas ocupacionales, incluyendo quién debe hacerlas, cómo deben hacerse, qué exámenes se requieren y cómo se debe manejar la información clínica de los trabajadores.<br /><br />

                  · Establecer un marco normativo actualizado para las evaluaciones médicas ocupacionales que deben realizar los empleadores y contratantes, alineado con las normas de salud y seguridad en el trabajo vigentes.<br /><br />

                  · Definir responsabilidades para empleadores, trabajadores y prestadores de servicios de salud ocupacional, garantizando condiciones de trabajo seguras y saludables.<br /><br />

                  · Protección de los derechos del trabajador, como la autonomía médica, la confidencialidad de la historia clínica ocupacional y la prohibición de prácticas discriminatorias (por ejemplo, pruebas de embarazo o VIH sin justificación técnica).<br /><br />

                  · Prevenir riesgos laborales y enfermedades profesionales mediante evaluaciones periódicas, preingreso, egreso y en momentos específicos (como retorno al trabajo o seguimiento) <br /><br />
                </p>

                  <h4 id="list-item-2">¿Quién debe Cumplir? </h4>
                   <p>
                    
                    · Empleadores de empresas públicas y privadas<br /><br />

                    · Contratistas y trabajadores tanto dependientes como independientes.<br /><br />

                    · Prestadores de servicios de Medicina y Seguridad y Salud en el Trabajo.<br /><br />

                    · Administradoras de Riesgos Laborales (ARL).<br /><br />

                  <h5>Obligaciones Empleadores</h5>

                    · Costear los exámenes ocupacionales y pruebas complementarias que pida el médico evaluador.<br /><br />

                    · Programar y realizar las evaluaciones dentro de la jornada laboral.<br /><br />

                    · Informar a los médicos los perfiles de los cargos y tareas para que las evaluaciones sean pertinentes<br /><br />

                    · Adaptar condiciones de trabajo según las restricciones o recomendaciones médicas en un plazo determinado<br /><br />

                  <h5>Obligaciones de los Trabajadores</h5>

                    · Proveer información veraz sobre su estado de salud.<br /><br />

                    · Atender las recomendaciones médicas tanto dentro como fuera del ambiente laboral.<br /><br />

                  <h5>Obligaciones de los prestadores de salud y profesionales</h5>

                    · Respetar la autonomía médica y la confidencialidad de las historias clínicas.<br /><br />

                    · Remitir al empleador solo el concepto médico ocupacional, no la historia médica completa.<br /><br />

                  <h5>Exámenes autorizados a realizar</h5>

                    · Pre- ingreso (antes de contratar)<br /><br />

                    · Periódicos (seguimiento de salud por exposición a riesgos)<br /><br />

                    · Cambio de Ocupación (si cambian funciones o riesgos).<br /><br />

                    · Además, contempla otros momentos como reincorporación tras incapacidad o egreso, con criterios técnicos <br /><br />
                  </p>
                  <h4 id="list-item-3">¿Cuál es la frecuencia definida para la realización de los exámenes médicos ocupacionales periódicos, de conformidad con la normatividad vigente? </h4>
                   <p>Según la Resolución 1843 de 2025 del Ministerio del Trabajo de Colombia, la periodicidad de los exámenes médicos ocupacionales periódicos no está fijada con una frecuencia única (como anual), sino que debe definirse dentro del programa de vigilancia epidemiológica del empleador, tomando en cuenta:<br /><br />

                    · El tipo, magnitud, frecuencia y tiempo de exposición a los factores de riesgo del cargo.<br /><br />

                    · La edad y estado de salud del trabajador.<br /><br />

                    · Los criterios técnicos definidos por la empresa en su Sistema de Gestión de Seguridad y Salud en el Trabajo (SG-SST).<br /><br />

                    · La empresa debe establecer con base técnica cada cuánto realizar los exámenes periódicos.<br /><br />

                    · Sin embargo, en general no pueden pasar más de 3 años entre evaluaciones, salvo excepción técnica bien fundamentada. <br /><br />
                   </p>
                  <h4 id="list-item-4">¿Cuáles son los criterios?</h4>
                   <p>
                    · La empresa no fija la frecuencia de manera arbitraria; debe hacerlo con base en criterios técnicos relacionados con el riesgo y la salud del trabajador.<br /><br />

                    · Tipo de riesgo (físico, químico, biológico, ergonómico, psicosocial, mecánico, etc.).<br /><br />

                    · Nivel del riesgo (alto, medio o bajo).<br /><br />

                    · Tiempo y frecuencia de exposición al riesgo.<br /><br />

                    · A mayor nivel de riesgo, menor debe ser el intervalo entre exámenes.<br /><br />

                  <h5>Tipo de cargo y tareas desempeñadas</h5>

                    · Cargos operativos o críticos (trabajo en alturas, conducción, manipulación de químicos, maquinaria pesada) suelen requerir mayor frecuencia.<br /><br />

                    · Cargos administrativos o de bajo riesgo pueden tener intervalos más amplios.<br /><br />

                  <h5>Resultados de exámenes médicos previos</h5>

                  Se analizan:<br /><br />

                    · Alteraciones encontradas.<br /><br />

                    · Tendencias de deterioro de la salud.<br /><br />

                    · Recomendaciones médicas previas.<br /><br />
                    
                  Si existen hallazgos relevantes, el seguimiento médico debe ser más frecuente.<br /><br />

                  <h5>Edad y condiciones de salud del trabajador</h5>

                    · Trabajadores mayores o con enfermedades crónicas pueden requerir controles más cercanos.<br /><br />

                    · Se prioriza la prevención de agravamiento de condiciones existentes.<br /><br />

                  <h5>Programas de Vigilancia Epidemiológica (PVE)</h5>
                  Cuando la empresa tenga PVE por ejemplo, para:<br /><br />

                    · Riesgo osteomuscular<br /><br />

                    · Ruido<br /><br />

                    · Sustancias químicas<br /><br />

                    · Riesgo psicosocial<br /><br />

                  La periodicidad debe ajustarse a lo definido en cada programa.<br /><br />

                  <h5>Cambios en las condiciones de trabajo</h5>

                  Se debe revisar la periodicidad si hay:<br /><br />

                    · Cambios en el cargo o funciones.<br /><br />

                    · Nuevos riesgos.<br /><br />
                    
                    · Modificación de procesos, equipos o sustancias. <br /><br />
                   </p>
                 
                  
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
